import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import { URI } from '../../Conexiones/Conexion';
import { getToken } from '../../Conexiones/Conexion';

const ModalAsisOfi = () => {

    const [lista,setLista]=useState([])
    const [empleadosOficina,setEmpOfi]=useState([])
    const navigate = useNavigate();

    useEffect( ()=>{
        const getAllEmpleados = async () =>{
            const res = await axios.get(URI+'empleadosOficina',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            setEmpOfi(res.data)
        }
        getAllEmpleados()
    }, [navigate])

    const addAsistencia = async (idE, nomE, appE, apmE) =>{
        if(document.getElementById(`cb${idE}`).checked){
            const asistencia = {idEmpleado: idE, nomEmpleado: nomE,
                apePaterno: appE, apeMaterno: apmE,obsL:''
                }
                setLista([...lista, asistencia])
                var obs = document.getElementById(`ob${idE}`)
                obs.disabled = false
        }else{
            var obsf = document.getElementById(`ob${idE}`)
            obsf.disabled = true
            obsf.value = null
            const falta = lista.filter((item) => item.idEmpleado !== idE) ;
            setLista(falta)
        }
        console.log(lista)
    }
    const handleChange = async (id) =>{
        const newUsers = lista.map((user) =>{
         if(user.idEmpleado === id){
             console.log(document.getElementById(`ob${id}`).value)
             return {...user, obsL: document.getElementById(`ob${id}`).value}
         }
         return user
        })
        setLista(newUsers)
     }

     const cancelar = async () => {
        if(lista.length === 0 ){
            navigate('/inicio/Oficina/AsisOficina')
            window.location.reload()
        }else{
            Swal.fire({
                title: '¿SEGURO QUE QUIERES SALIR?',
                text: "UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS",
                icon: 'warning',
                iconColor:'#1e2c4f',
                color: '#1e2c4f',
                showCancelButton: true,
                confirmButtonColor: '#1e2c4f',
                cancelButtonColor: '#d33',
                confirmButtonText: 'SALIR',
                cancelButtonText: 'CANCELAR'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/inicio/Oficina/AsisOficina')
                    window.location.reload()
                }
            })   
        } 
    }

    const guardarAsistencia = async (e) => {
        e.preventDefault()
        var listaAsistencia = JSON.stringify(lista);
        await axios.post(URI+'createAsisOfis/',{lista:listaAsistencia},{
            headers: {
                'Content-Type': 'application/json',
            },
            }).then(
            res => {
                if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                    console.log('error conexion')
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                        )
                }else{
                    console.log(res.data)
                    if(res.data.message==="SE GUARDÓ ASISTENCIA CORRECTAMENTE"){
                        console.log(res.data.message)
                        Swal.fire({
                            icon: 'success',
                            title: res.data.message,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            //timer: 1500
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload();
                            } 
                        })
                    }else{
                        console.log(res.data.message)
                        Swal.fire({
                            title: '¡ERROR!',
                            text: res.data.message,                 
                            icon: 'error',
                            confirmButtonColor: 'red',
                            allowOutsideClick: false,
                            confirmButtonText: 'ACEPTAR'
                        })
                    }
                }
            }
        ).catch(
            err => {
                console.log(err);
                console.log(err.message)
                console.log(typeof(err.message))
                if(err.message === "Network Error"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                    )
                }else{
                    Swal.fire(
                        'Falla en el servidor...',
                        err.message,
                        'question'
                    )
                }
            }
        )
    }

    return (
        <div>
        <div className="modal fade" id="modal-agregar" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header btncolor" >
                        <h5 className="modal-title " id="exampleModalLabel">ASISTENCIA DE OFICINA</h5>
                        <button type="button" className="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>
                
                    <div className="modal-body" >
                    <div className="tablaHerramientas">
                            
                            { empleadosOficina.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                            <div className="caja-asistencia" >
                                <div className="table tabla">
                                    <table className="table  text-uppercase">
                                        <thead >
                                            <tr >
                                            <th>EMPLEADO</th>
                                            <th>ASISTENCIA</th>
                                            <th>OBSERVACIONES</th>
                                        </tr>
                                </thead>
                                <tbody >
                                {empleadosOficina.map(p =>{
                                    return(
                                        <tr key={p.idEmpleado}>
                                            <td>{p.nombreEmp} {p.apellidoPaternoEmp} {p.apellidoMaternoEmp}</td>
                                            <td>
                                                <input type="checkbox" id={`cb${p.idEmpleado}`} 
                                                    onClick={()=>addAsistencia(
                                                    p.idEmpleado, p.nombreEmp, p.apellidoPaternoEmp, 
                                                    p.apellidoMaternoEmp
                                                    )}
                                                />
                                            </td>
                                            <td>
                                                            <input type="text" id={`ob${p.idEmpleado}`} onChange={()=>handleChange(p.idEmpleado)} disabled/>
                                            </td>
                                            </tr>                             
                                        )
                                    })}                        
                                </tbody>
                            </table>
                        </div>           
                    </div>
                        )}
                
                    </div>
                    </div>
                        <div className="modal-footer justify-content-center" style={{clear:'both'}}>
                            <button type="button" className="btn btn-secondary" onClick={cancelar} >CANCELAR</button>
                            {lista.length === 0 ? (
                                <button type="button" className="btn btn-light btncolor" disabled>GUARDAR ASISTENCIA</button> 
                            ):(
                                <button type="button" className="btn btncolor" data-bs-toggle="modal" data-bs-target="#modal-confirmar-asistencia" >GUARDAR ASISTENCIA</button>
                            )}
                            
                        </div>
                
                </div>
            </div>
        </div>
            <div className="modal fade" id="modal-confirmar-asistencia" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog ">
                    <div className="modal-content">
                    <div className="modal-header btncolor" >
                        <h5 className="modal-title" id="exampleModalLabel">VERIFICAR ASISTENCIA</h5>
                        <button type="button" className="btn-close bg-white" data-bs-toggle="modal" data-bs-target="#modal-asistencia" aria-label="Close" ></button>
                    </div>
                    <div className="modal-body" >
                        <div className="mb-6">
                            <strong><label className="form-label">LISTA DE ASISTENCIA</label></strong>
                        </div>
                        <div className="mb-6" >
                            <div className="table-responsive" >
                                <table style={{width:'100%'}}>
                                    <thead >
                                        <tr >
                                            <th>EMPLEADO</th>
                                            <th>ASISTENCIA</th>
                                            <th>OBSERVACIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {lista.map(l =>{
                                            return(
                                                <tr key={l.idEmpleado}>
                                                    <td>{l.nomEmpleado} {l.apePaterno} {l.apeMaterno}</td>
                                                    <td>
                                                        <input className="form-check-input" type="checkbox" checked disabled />
                                                    </td>
                                                    <td>{l.obsL}</td>
                                                </tr>                   
                                            )
                                        })}                        
                                    </tbody>
                                </table>
                            </div>           
                        </div>             
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={cancelar} >CANCELAR</button>                                               
                        <button type="button" className="btn btncolor" onClick={guardarAsistencia} >ACEPTAR</button>                                                
                    </div>
                    
                    </div>
                </div>
            </div>
</div>
    );
};

export default ModalAsisOfi;